module.exports = __webpack_public_path__ + "Icono_Mas_126px.png";